import fetch from 'isomorphic-fetch'
import { includes, indexOf } from 'lodash'
import { retrieveStore } from './store'
import { toTitleCase } from '../helpers/stringHelpers'
import * as CookieHelper from '../helpers/cookieHelpers'

export const FETCH_STORES = 'FETCH_STORES'
export const FETCH_STORES_REJECTED = 'FETCH_STORES_REJECTED'
export const FETCH_STORES_FULFILLED = 'FETCH_STORES_FULFILLED'
export const FETCH_STORES_FULFILLED_NO_STORES = 'FETCH_STORES_FULFILLED_NO_STORES'

export const FETCH_ALL_STORES = 'FETCH_ALL_STORES'
export const FETCH_ALL_STORES_REJECTED = 'FETCH_ALL_STORES_REJECTED'
export const FETCH_ALL_STORES_FULFILLED = 'FETCH_ALL_STORES_FULFILLED'

export const FETCH_STORE = 'FETCH_STORE'
export const FETCH_STORE_REJECTED = 'FETCH_STORE_REJECTED'
export const FETCH_STORE_FULFILLED = 'FETCH_STORE_FULFILLED'

export const FETCH_RECENTLY_SEARCHED_LOCATIONS = 'FETCH_RECENTLY_SEARCHED_LOCATIONS'
export const FETCH_RECENTLY_SEARCHED_LOCATIONS_REJECTED = 'FETCH_RECENTLY_SEARCHED_LOCATIONS_REJECTED'
export const FETCH_RECENTLY_SEARCHED_LOCATIONS_FULFILLED = 'FETCH_RECENTLY_SEARCHED_LOCATIONS_FULFILLED'

export const SAVE_RECENTLY_SEARCHED_LOCATION = 'SAVE_RECENTLY_SEARCHED_LOCATION'
export const SAVE_SEARCH_TERM = 'SAVE_SEARCH_TERM'
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION'
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE'
export const SET_LOADING = 'SET_LOADING'
export const SET_VIEW_TYPE = 'SET_VIEW_TYPE'
export const SET_AZ_LIST_VISIBLE = 'SET_AZ_LIST_VISIBLE'

export function saveSearchTerm (searchTerm) {
  return {
    type: SAVE_SEARCH_TERM,
    payload: searchTerm
  }
}

export function setAZListVisibility (isVisible) {
  return {
    type: SET_AZ_LIST_VISIBLE,
    payload: isVisible
  }
}

export function setViewType (viewType) {
  return {
    type: SET_VIEW_TYPE,
    payload: viewType
  }
}

export function setRecentlySearchedLocation (searchTerm) {
  if (!global.window || searchTerm.length === 0) {
    return {
      type: FETCH_RECENTLY_SEARCHED_LOCATIONS_REJECTED,
      payload: []
    }
  }
  let recentlySearchedCookie = JSON.parse(CookieHelper.getCookie('sl_recently_searched'))
  searchTerm = toTitleCase(searchTerm)
  if (!recentlySearchedCookie || recentlySearchedCookie === null) {
    recentlySearchedCookie = [searchTerm]
  } else {
    if (!includes(recentlySearchedCookie, searchTerm)) {
      recentlySearchedCookie.unshift(searchTerm)
      recentlySearchedCookie = recentlySearchedCookie.slice(0, 5)
    } else {
      const index = indexOf(recentlySearchedCookie, searchTerm)
      if (index > -1) {
        recentlySearchedCookie.splice(index, 1)
        recentlySearchedCookie.unshift(searchTerm)
      }
    }
  }
  CookieHelper.setCookie('sl_recently_searched', JSON.stringify(recentlySearchedCookie), 30)
  return {
    type: SAVE_RECENTLY_SEARCHED_LOCATION,
    payload: recentlySearchedCookie
  }
}

export function getRecentlySearchedLocations () {
  const recentlySearchedLocationsFromCookie = JSON.parse(CookieHelper.getCookie('sl_recently_searched'))
  if (recentlySearchedLocationsFromCookie === false) {
    return {
      type: FETCH_RECENTLY_SEARCHED_LOCATIONS_REJECTED,
      payload: []
    }
  } else {
    return {
      type: FETCH_RECENTLY_SEARCHED_LOCATIONS_FULFILLED,
      payload: recentlySearchedLocationsFromCookie
    }
  }
}

export function fetchSearchResults (query, fromServer = false) {
  const errorMessage = 'Bad response from server'
  const encodequery = encodeURI(query)
  const url = fromServer ? 'http://127.0.0.1:3000/stores/api/storefinder/' : '/stores/api/storefinder/'
  return dispatch => {
    dispatch(setLoading(true))
    return fetch(url + '?maxResults=10&maxDistance=50&origin=' + encodequery)
      .then(response => {
        if (response.status >= 400) {
          dispatch(receiveError(errorMessage))
          dispatch(setLoading(false))
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(results => {
        if (results && results.stores.length > 0) {
          if (!query.match(/\d+/g)) setRecentlySearchedLocation(query)
          return dispatch(fetchStores(results.stores, fromServer))
        }
        if (results && results.suggestions.length > 0) {
          return dispatch(receiveDidYouMean(results.suggestions))
        }
      })
  }
}

export function receiveError (error) {
  return {
    type: FETCH_STORES_REJECTED,
    payload: error
  }
}

export function fetchStores (results, fromServer = false) {
  const errorMessage = 'Bad response from server'
  return dispatch => {
    const promises = results.map((store) => {
      const storeId = store.store_id
      const url = fromServer ? 'https://api.homeretailgroup.com/storeinfo/v0/stores/' + storeId + '?apiKey=ff6r7umkc6sa3kjcg5enfakm' : '/stores/api/store/' + storeId
      return fetch(url)
        .then((response) => {
          if (response.status >= 400 && response.status !== 404) {
            throw new Error(errorMessage)
          }
          return response.json()
        })
        .then((newStore) => retrieveStore(newStore, store, storeId))
    })
    return Promise.all(promises)
      .then(stores => dispatch(retrieveStores(stores)))
  }
}

export function retrieveStores (stores) {
  return {
    type: FETCH_STORES_FULFILLED,
    payload: stores
  }
}

export function receiveDidYouMean (results) {
  return {
    type: FETCH_STORES_FULFILLED_NO_STORES,
    payload: results
  }
}

export function setLoading (flag) {
  return {
    type: SET_LOADING,
    payload: flag
  }
}

export function setCurrentLocation (lng, lat) {
  return {
    type: SET_CURRENT_LOCATION,
    payload: {lat: lat, lng: lng}
  }
}

export function setCurrentStore (storeId, order) {
  return {
    type: SET_CURRENT_STORE,
    payload: {
      id: storeId,
      order: order
    }
  }
}

export function fetchAllStores () {
  const errorMessage = 'Bad response from server'
  return dispatch => {
    return fetch('https://api.homeretailgroup.com/storeinfo/v0/stores/?apiKey=ff6r7umkc6sa3kjcg5enfakm')
      .then(response => {
        if (response.status >= 400) {
          throw new Error(errorMessage)
        }
        return response.json()
      })
      .then(results => {
        return dispatch(retrieveAllStores(results))
      })
  }
}

export function retrieveAllStores (results) {
  return {
    type: FETCH_ALL_STORES_FULFILLED,
    payload: results
  }
}



// WEBPACK FOOTER //
// ./src/actions/locator.js